import React, { useState, useEffect, useMemo } from 'react'
import lodash from 'lodash'
import styled from 'styled-components'

import LimitedQuantity from './LimitedQuantity'
import ForbiddenByLaw from './ForbiddenByLaw'

// validation for a single hazmat item
const HazmatValidation = (props) => {
  const {} = props

  return (
    <>
      <LimitedQuantity />
      <ForbiddenByLaw />
    </>
  )
}

export default HazmatValidation
